// @import services
import UserService from 'app_services/user/userService'
// @end

class PermissionService {

  private userService: UserService = new UserService()
  private moduleName: string

  constructor(moduleName: string) {
    this.moduleName = moduleName
  }

  /**
   * Metodo que concede/deniega el acceso a una accion dentro del sistema
   * @param permission Permiso que se desea validar
   * @param callback Accion que se ejecutara
   * @returns
   */
  check = (permission: string, callback: any) => {
    if (!this.userService.can(`${permission}`, this.moduleName)){
      return false
    } else {
      return callback
    }
  }

  /**
   * Metodo que concede/deniega el acceso a una accion dentro del sistema
   * @param permission Permiso que se desea validar
   * @param callback Accion que se ejecutara
   * @returns
   */
   checkSimple = (permission: string) => {
    if (!this.userService.can(`${permission}`, this.moduleName)){
      return false
    } else {
      return true
    }
  }

}

export default PermissionService
